import { useState } from "react";
/**
 * vendor
 */

/* components
 */
import { AccordionContext } from "common/contexts";
import Accordion from "components/atoms/Accordion";

const FaqsGroup = ({
  data,
  haveTabs,
  defaultActiveKey,
  multipleOpen,
  icon,
  ...props
}) => {
  const [listKey] = useState(() => {
    if (Array.isArray(data)) {
      return data?.map((item) => item.name.toLowerCase().split(" ").join("-"));
    } else {
      return data?.data.map((item) =>
        item.name.toLowerCase().split(" ").join("-")
      );
    }
  });
  const [active, setActive] = useState([listKey[defaultActiveKey]]);
  return (
    <AccordionContext.Provider value={{ active, setActive }}>
      <Accordion
        icon={icon}
        list={data}
        multipleOpen={multipleOpen}
        buttonClass={props.buttonClass}
        panelClass={props.panelClass}
        {...props}
      />
    </AccordionContext.Provider>
  );
};

export default FaqsGroup;
